import React from "react";
import { Mail, Phone, MessageSquare } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export default function LeadsTable({ leads }) {
  if (!leads || leads.length === 0) {
    return (
      <div data-testid="admin-empty-state" className="px-6 py-20 text-center">
        <div className="w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-4" style={{ background: "var(--np-quaternary)" }}>
          <Mail size={22} style={{ color: "var(--np-secondary)" }} />
        </div>
        <p className="text-lg" style={{ color: "var(--np-primary)", fontFamily: "Merriweather, serif" }}>Nessun risultato</p>
        <p className="text-sm mt-1" style={{ color: "var(--np-muted)" }}>Appena un visitatore compilerà il modulo, lo vedrai qui.</p>
      </div>
    );
  }
  return (
    <Table data-testid="admin-leads-table">
      <TableHeader>
        <TableRow className="bg-[#f7fafd] hover:bg-[#f7fafd]">
          <TableHead className="font-semibold text-[12px] tracking-wider uppercase" style={{ color: "var(--np-primary)" }}>Data</TableHead>
          <TableHead className="font-semibold text-[12px] tracking-wider uppercase" style={{ color: "var(--np-primary)" }}>Nome</TableHead>
          <TableHead className="font-semibold text-[12px] tracking-wider uppercase" style={{ color: "var(--np-primary)" }}>Email</TableHead>
          <TableHead className="font-semibold text-[12px] tracking-wider uppercase" style={{ color: "var(--np-primary)" }}>Telefono</TableHead>
          <TableHead className="font-semibold text-[12px] tracking-wider uppercase" style={{ color: "var(--np-primary)" }}>Messaggio</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {leads.map((l) => (
          <TableRow key={l.id} data-testid="admin-lead-row" className="align-top hover:bg-[#fafcfe]">
            <TableCell className="whitespace-nowrap text-sm" style={{ color: "var(--np-muted)" }}>{fmt(l.created_at)}</TableCell>
            <TableCell className="font-medium" style={{ color: "var(--np-primary)" }}>{l.name}</TableCell>
            <TableCell>
              <a href={`mailto:${l.email}`} className="inline-flex items-center gap-1.5 text-sm hover:underline" style={{ color: "var(--np-secondary)" }}>
                <Mail size={13} />{l.email}
              </a>
            </TableCell>
            <TableCell>
              <a href={`tel:${l.phone}`} className="inline-flex items-center gap-1.5 text-sm hover:underline" style={{ color: "var(--np-primary)" }}>
                <Phone size={13} />{l.phone}
              </a>
            </TableCell>
            <TableCell className="max-w-[360px]">
              {l.message ? (
                <div className="flex items-start gap-1.5 text-sm leading-relaxed" style={{ color: "#2a3a4a" }}>
                  <MessageSquare size={13} className="mt-1 shrink-0" style={{ color: "var(--np-muted)" }} />
                  <span className="whitespace-pre-wrap">{l.message}</span>
                </div>
              ) : (<span className="text-xs italic" style={{ color: "var(--np-muted)" }}>—</span>)}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
